import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { MarketInfoService } from './MarketInfoService.service';
@Injectable({
  providedIn: 'root',
})

export class AuctionService {
  private baseURL: string;
  constructor(private http: HttpClient, private marketInfoService: MarketInfoService
  ) {
    this.baseURL = environment.apiBaseUrl;
  }

  public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };


  GetBidTypes(marketId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GetBidTypes?marketId=${marketId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetVendorBidEntry(MarketId,VendorId, YearMonth): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Rental/GetVendorBidEntry?marketId=${MarketId}&VendorId=${VendorId}&YearMonth=${YearMonth}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  SaveVendorBidEntry(marketId,vendorId, yearMonth, model): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/Rental/SaveVendorBidEntry?marketId=${marketId}&VendorId=${vendorId}&YearMonth=${yearMonth}`,
      model,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    ).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
